const getEmptyDataRedirect = (data, errors) => {
  if (errors && !data) return '/';
  if (!data) return false;
  const { results = [] } = data || {};

  if (!results || (results && !results.length)) return '/guides';

  return false;
};

const redirects = ({ data, errors }) => {
  const { localsearchCMSArticles } = data || {};
  const redirectArray = [getEmptyDataRedirect(localsearchCMSArticles, errors)];

  return redirectArray.find(url => url);
};

export default redirects;
